export class RegitrationOrganization
{
    public Name: string;
    public Addr1: string;
    public Addr2 = '';
    public Phone = '';
    public Country: string;
    public City: string;
    public State: string;
    public PostalCode: string;
}
